import { Suspense } from "react";
import { useParams } from "react-router-dom";
import { Insureframe } from "../components/Insureframe/Insureframe";

export default function CascoSummary() {
  const { offerId } = useParams();

  return (
    <>
      <section className="relative overflow-hidden pb-150 pt-[150px] max-md:pt-150">
        <div className="container">
          <Suspense>
            <Insureframe
              product="casco"
              offerId={offerId}
              insureframeUrl={import.meta.env.VITE_INSUREFRAME_URL}
              insureframeApiKey={import.meta.env.VITE_INSUREFRAME_APIKEY}
              insureframeCutomUrl={import.meta.env.VITE_INSUREFRAME_CUSTOM_URL}
            />
          </Suspense>
        </div>
      </section>
    </>
  );
}
